import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.priceLists;
export const priceListsRoute = {
    path: rootPath,
    lazy: async () => {
        const { PriceListsContainer } = await import('@/admin/modules/priceLists');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(PriceListsContainer, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
